<div class="ld-media-item">
  <figure data-responsive-bg="true">
    <!-- alt is empty on purpose: the tile's name lives on the link below, and
         a duplicate name makes a screen reader read the item twice. -->
    <img class="invisible" [src]="item?.image" alt="" />
  </figure>
  <div class="ld-media-item-overlay d-flex flex-column align-items-center text-center justify-content-center">
    <div class="ld-media-bg"></div>
    <div class="ld-media-content">
      <span class="ld-media-icon"><span class="ld-media-icon-inner"><i [class]="iconClass" aria-hidden="true"></i></span></span>
    </div>
  </div>
  <a
    [href]="item?.url"
    class="liquid-overlay-link fresco"
    [attr.data-fresco-group]="group"
    [attr.aria-label]="label"
    (click)="onOpen()"
  ></a>
</div>
<!-- Text binding, not [innerHTML] | safe. The captions are plain text (checked:
     0 of 119 gallery rows contain markup), and every safe:'html' binding on this
     site disables Angular's sanitizer - see FINDING-innerhtml-xss. No reason to
     add another one for a string that never holds markup. -->
<h6 class="ld-pf-title font-weight-bold text-center mb-3" *ngIf="showCaption">{{ item?.caption }}</h6>
